module.exports = __webpack_public_path__ + "static/media/rightArr.43efb184.svg";